<style scoped>
a {
  text-decoration: none;
  color: #555 !important;
}
</style>

<template>
  <div>
    <v-card-text>
      <v-form ref="form" @submit="submit">
        <v-text-field
          id="login-form-username"
          label="Username"
          name="login"
          v-model="model.username"
          type="text"
          required
          suffix=" "
          prefix=" "
          :rules="rules.username"
          v-on:keyup.enter="submit"
        />
        <v-text-field
          id="login-form-password"
          label="Password"
          name="password"
          v-model="model.password"
          type="password"
          required
          suffix=" "
          prefix=" "
          :rules="rules.password"
          v-on:keyup.enter="submit"
        />
        <span class="float-right">
          <router-link tag="a" :to="{ name: 'ForgotPasswordView' }">
            Forgot Password?
          </router-link>
        </span>
      </v-form>
    </v-card-text>
    <v-card-text class="pb-2">
      <v-row>
        <v-col class="text-center pb-0">
          <v-btn
            large
            class="elevation-0 unauth-action-btn unauth-submit-btn"
            @click="submit"
            :loading="loading"
          >
            <span>Login</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center" class="mt-2 mb-0 pt-0 pb-0">
          <span>or</span>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import MODEL from './resources/model';
import RULES from './resources/rules';

export default {
  data: vm => ({
    model: vm.$utils.deepCopy(MODEL),
    rules: RULES,
    loading: false,
  }),
  methods: {
    submit() {
      const formIsValid = this.$refs.form.validate();
      if (formIsValid) {
        this.loading = true;
        this.$requests.post('auth', this.model)
          .then(response => {
            this.$emit('success', response.data);
          })
          .catch(err => {
            let msg = String();
            try {
              msg = err.response.data.message;
            } catch (_) {
              msg = 'Invalid username and password';
            }
            this.$toast.error(msg, { timeout: 5000 });
            if (err.response.status === 403) {
              this.$router.push({ name: 'ForgotPasswordView' });
            }
          })
          .then(() => { this.loading = false; });
      }
    },
  },
};
</script>
